module.exports = __webpack_public_path__ + "static/img/200052.4e8ead3a.png";